var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "draggable",
    {
      staticClass: "draggable-group-container",
      attrs: {
        ghostClass: "ghost",
        group: {
          name: "layers",
          pull: true,
          put: true,
        },
        handle: ".draggable-handle",
      },
      on: {
        choose: _vm.onChooseGroupItem,
        end: function ($event) {
          return _vm.onEnd($event)
        },
      },
      model: {
        value: _vm.treeLayer,
        callback: function ($$v) {
          _vm.treeLayer = $$v
        },
        expression: "treeLayer",
      },
    },
    [
      _vm._l(_vm.treeLayer, function (layerGroup, index) {
        return [
          layerGroup.isGroup
            ? _c(
                "div",
                {
                  key: layerGroup.id + "_" + index,
                  staticClass: "draggable__item",
                },
                [
                  _c(
                    "DraggableListItem",
                    {
                      staticClass: "draggable-group__item",
                      attrs: { disabledDrag: _vm.disabledDrag },
                    },
                    [
                      _c("div", { staticClass: "draggable-group__info" }, [
                        _c(
                          "span",
                          {
                            staticClass: "draggable-group__title",
                            attrs: { title: layerGroup.name },
                          },
                          [_vm._v(" " + _vm._s(layerGroup.name) + " ")]
                        ),
                        _c(
                          "div",
                          { staticClass: "draggable-group__action" },
                          [
                            layerGroup.children &&
                            layerGroup.children.length > 0
                              ? [
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.unGroup(layerGroup, index)
                                        },
                                      },
                                    },
                                    [
                                      _c("SvgIcon", {
                                        attrs: {
                                          size: "14",
                                          type: "mdi",
                                          path: _vm.path.group.unGroup,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                            _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteGroup(layerGroup, index)
                                  },
                                },
                              },
                              [
                                _c("SvgIcon", {
                                  attrs: {
                                    size: "14",
                                    type: "mdi",
                                    path: _vm.path.group.delete,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleShowChildrenGroup(
                                      layerGroup.id
                                    )
                                  },
                                },
                              },
                              [
                                _vm.isGroupShow[layerGroup.id]
                                  ? _c("SvgIcon", {
                                      attrs: {
                                        size: "14",
                                        type: "mdi",
                                        path: _vm.path.group.close,
                                      },
                                    })
                                  : _c("SvgIcon", {
                                      attrs: {
                                        size: "14",
                                        type: "mdi",
                                        path: _vm.path.group.open,
                                      },
                                    }),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ]),
                      _vm.isGroupShow[layerGroup.id]
                        ? _c("div", { staticClass: "draggable-group__divider" })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          class: {
                            "draggable-group__children-container":
                              _vm.isGroupShow[layerGroup.id],
                          },
                        },
                        [
                          !layerGroup.children || layerGroup.children.length < 1
                            ? _c(
                                "div",
                                { staticClass: "draggable-group__nodata" },
                                [_vm._v(" Drag layer inside this group ")]
                              )
                            : _vm._e(),
                          _c(
                            "draggable",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isGroupShow[layerGroup.id],
                                  expression: "isGroupShow[layerGroup.id]",
                                },
                              ],
                              staticClass: "draggable-group__children",
                              attrs: {
                                ghostClass: "ghost",
                                group: {
                                  name: "layers",
                                  pull: true,
                                  put: _vm.checkItemCanPutInChildren,
                                },
                                handle: ".draggable-handle",
                              },
                              on: {
                                end: function ($event) {
                                  return _vm.onEnd($event)
                                },
                              },
                              model: {
                                value: layerGroup.children,
                                callback: function ($$v) {
                                  _vm.$set(layerGroup, "children", $$v)
                                },
                                expression: "layerGroup.children",
                              },
                            },
                            _vm._l(
                              layerGroup.children,
                              function (element, element_index) {
                                return _c(
                                  "div",
                                  {
                                    key:
                                      element.id +
                                      "_" +
                                      index +
                                      "_" +
                                      element_index,
                                    staticClass: "draggable__item",
                                  },
                                  [
                                    _c(
                                      "DraggableListItem",
                                      {
                                        attrs: {
                                          disabledDrag: _vm.disabledDrag,
                                          isSelected:
                                            _vm.currentSelectId.includes(
                                              element.id
                                            ),
                                          item: element,
                                        },
                                      },
                                      [
                                        _vm._t("item", null, {
                                          group: layerGroup,
                                          isSelected:
                                            _vm.currentSelectId.includes(
                                              element.id
                                            ),
                                          item: element,
                                          toggleSelect: _vm.toggleSelect,
                                        }),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _c(
                "div",
                {
                  key: layerGroup.id + "_" + index + "_else",
                  staticClass: "draggable__item",
                },
                [
                  _c(
                    "DraggableListItem",
                    {
                      attrs: {
                        disabledDrag: _vm.disabledDrag,
                        isSelected: _vm.currentSelectId.includes(layerGroup.id),
                        item: layerGroup,
                      },
                    },
                    [
                      _vm._t("item", null, {
                        isSelected: _vm.currentSelectId.includes(layerGroup.id),
                        item: layerGroup,
                        index: index,
                        toggleSelect: _vm.toggleSelect,
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }